import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Output,
    SimpleChanges,
    OnChanges,
    EventEmitter,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EducationAndTrainingDto } from '../../../core/dto/education-and-training';
import { IsavValidators } from '../../../utils/forms/validators';

@Component({
    selector: 'isav-education-and-trening-form',
    templateUrl: './education-and-trening-form.html',
    styleUrls: ['./education-and-trening-form.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EducationAndTreningForm implements OnChanges {
    @Input() value: Partial<EducationAndTrainingDto>;
    @Output() save = new EventEmitter<Partial<EducationAndTrainingDto>>();
    @Output() remove = new EventEmitter<void>();
    @Output() publish = new EventEmitter<EducationAndTrainingDto>();
    @Output() unpublish = new EventEmitter<void>();

    form = new UntypedFormGroup(
        {
            title: new UntypedFormControl(null, [IsavValidators.required('Title is required!')]),
            education: new UntypedFormControl(null, [
                IsavValidators.required('Education or training is required!'),
            ]),
            startDate: new UntypedFormControl(null, [
                IsavValidators.required('Start date is required!'),
            ]),
            endDate: new UntypedFormControl(null, [
                IsavValidators.required('End date is required!'),
            ]),
            registrationDeadline: new UntypedFormControl(null, [
                IsavValidators.required('Registration deadline is required!'),
            ]),
            organisation: new UntypedFormControl(null, [
                IsavValidators.required('Organisation is required!'),
            ]),
            departments: new UntypedFormControl(null),
            linkToCourseRegistration: new UntypedFormControl(null, [
                IsavValidators.required('Link to course description is required!'),
            ]),
            courseLevel: new UntypedFormControl(null, [
                IsavValidators.required('Course level is required!'),
            ]),
            studyField: new UntypedFormControl(null, [
                IsavValidators.required('Study field is required!'),
            ]),
            topics: new UntypedFormControl(null),
            languages: new UntypedFormControl(null),
            ects: new UntypedFormControl(null),
            teachingCountry: new UntypedFormControl(null, [
                IsavValidators.required('Teaching country is required!'),
            ]),
            teachingLocation: new UntypedFormControl(null, [
                IsavValidators.coordinates('Teaching location is required!'),
            ]),
            contactName: new UntypedFormControl(null, [
                IsavValidators.required('Contact name is required!'),
            ]),
            contactEmail: new UntypedFormControl(null, [
                IsavValidators.required('Contact email is required!'),
            ]),
            contactPhone: new UntypedFormControl(null, [
                IsavValidators.required('Contact phone is required!'),
            ]),
            image: new UntypedFormControl(null),
            shortDescription: new UntypedFormControl(null, [
                IsavValidators.required('Description is required!'),
            ]),
            attachments: new UntypedFormControl(null),
        },
        {
            validators: IsavValidators.dates(
                'startDate',
                'endDate',
                'Start date cannot be after the end date!'
            ),
        }
    );

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && this.value) {
            this.form.reset(this.value);
        }
    }

    onSave() {
        if (!this.form.value.education) this.clearEducationValues();
        this.save.emit({
            ...this.form.value,
        });
    }

    onDelete() {
        this.remove.emit();
    }

    onPublish() {
        if (!this.form.value.education) this.clearEducationValues();
        this.publish.emit({
            ...this.form.value,
        });
    }

    onUnpublish() {
        this.unpublish.emit();
    }

    clearEducationValues() {
        this.form.get('courseLevel')!.setValue(null);
        this.form.get('studyField')!.setValue(null);
        this.form.get('ects')!.setValue(null);
    }

    isDisabled() {
        if (this.form.value.education) return !this.form.valid;
        return !this.isFormTrainingValid();
    }

    isFormTrainingValid() {
        if (!this.form.get('title')!.valid) return false;
        if (!this.form.get('startDate')!.valid) return false;
        if (!this.form.get('endDate')!.valid) return false;
        if (!this.form.get('registrationDeadline')!.valid) return false;
        if (!this.form.get('organisation')!.valid) return false;
        if (!this.form.get('linkToCourseRegistration')!.valid) return false;
        if (!this.form.get('teachingCountry')!.valid) return false;
        if (!this.form.get('teachingLocation')!.valid) return false;
        if (!this.form.get('contactName')!.valid) return false;
        if (!this.form.get('contactEmail')!.valid) return false;
        if (!this.form.get('contactPhone')!.valid) return false;
        if (!this.form.get('contactName')!.valid) return false;
        if (!this.form.get('shortDescription')!.valid) return false;
        return true;
    }
}
